const WtkInfoPanel = ({ icon, pg1, pg2, pq }) => {
  return (
    <div className="wtkPanel">
      <div className="wtkPanel__left">
        <img src={icon} alt="graphic icon" />
        <p>{pg1}</p>
        <p>{pg2}</p>
      </div>
      <div className="wtkPanel__right">
        <img src={pq} alt="graphic icon" />
      </div>
    </div>
  );
};

export default WtkInfoPanel;
